<div class="a00290">
    <div class="a00290__container">
        <div class="text" *ngFor="let item of menu">
            <a [href]="item.link" [attr.target]="item.target">
                {{ item.name }}
            </a>
        </div>
    </div>
</div>
